const TEAM = [
  { name: 'Bharat Jain', role: 'Founder', initials: 'BJ', linkedin: 'https://www.linkedin.com/' },
  { name: 'Yash Maliya', role: 'Co-Founder - Strategy & Business', initials: 'YM', linkedin: 'https://www.linkedin.com/' },
  { name: 'Prathamesh Bhujbal', role: 'Co-Founder - Product', initials: 'PB', linkedin: 'https://www.linkedin.com/' },
];

function LinkedInLogo() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden focusable="false">
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.8 0 0 .78 0 1.75v20.5C0 23.22.8 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.75V1.75C24 .78 23.2 0 22.22 0z" />
    </svg>
  );
}

export default function TeamGrid() {
  return (
    <div className="team">
      {TEAM.map((m) => (
        <div className="team__member" key={m.name}>
          {m.photo ? (
            <img className="avatar" src={m.photo} alt={m.name} />
          ) : (
            <div className="avatar" aria-hidden>{m.initials}</div>
          )}
          <p className="team__name">{m.name}</p>
          <p className="team__role">{m.role}</p>
          <a
            className="team__linkedin"
            href={m.linkedin}
            target="_blank"
            rel="noreferrer"
            aria-label={`${m.name} on LinkedIn`}
          >
            <LinkedInLogo />
          </a>
        </div>
      ))}
    </div>
  );
}
